import { ActionOverRecordTypes, triggerAction, IActionsSchema, ZendraLocalizationServices, FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CostReceiverService, PlanTypeService, PropertyService } from 'cbd-proxies';

FieldBuilder.setNamespace('Operational');

const buildTechnicalIdField = (key: string, label: string): FieldDefinition => {
  const field = FieldBuilder.number(key, label)
    .readOnly()
    .hideInChildForms()
    .hideByDefault()
    .build();
  field.column.params = { ...field.column.params, excludeFromExport: true };
  return field;
};

export const HARVESTPLAN_FIELDS: FieldDefinition[] = [
  buildTechnicalIdField(
    'standLocationId',
    'Entity.HarvestPlan.StandLocationId',
  ),
  FieldBuilder
    .text('team', 'Entity.HarvestPlan.Team')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .number('year', 'Entity.HarvestPlan.Year')
    .required()
    .build(),
  FieldBuilder
    .date('validDate', 'Entity.HarvestPlan.ValidDate')
    .required()
    .build(),
  FieldBuilder
    .number('volume', 'Entity.HarvestPlan.Volume')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .text('planVersion', 'Entity.HarvestPlan.PlanVersion')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .number('planNumber', 'Entity.HarvestPlan.PlanNumber')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'costReceiverId',
    'Entity.HarvestPlan.CostReceiver',
    CostReceiverService
  )
    .required()
    .display('name')
    .displayFromNested('costReceiverName')
    .sortBy('costReceiverName')
    .keyField('id')
    .displayFromNested('costReceiverName')
    .sortBy('costReceiverName')
    .build(),
  FieldBuilder
    .number('costReceiverCycle', 'Entity.HarvestPlan.CostReceiverCycle')
    .hideInChildForms()
    .readOnly()
    .build(),
  FieldBuilder
    .number('costReceiverRotation', 'Entity.HarvestPlan.CostReceiverRotation')
    .hideInChildForms()
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'planTypeId',
    'Entity.PlanType',
    PlanTypeService
  )
    .required()
    .display('name')
    .displayFromNested('planTypeName')
    .sortBy('planTypeName')
    .keyField('id')
    .readOnly()
    .showReadOnlyInForm()
    .build(),
  FieldBuilder
    .number('versionId', 'Entity.HarvestPlan.VersionId')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'propertyId',
    'Entity.Property',
    PropertyService
  )
    .display('name')
    .displayFromNested('propertyName')
    .sortBy('propertyName')
    .readOnly()
    .build(),
];

export const ACTION_IDS = {
  importExcelModal: 0,
  downloadExcelTemplateTrigger: 1,
} as const;

export const HARVEST_PLAN_ACTION_IDS = ACTION_IDS;

export const HARVESTPLAN_ACTIONS: IActionsSchema = {
  overTable: [
    triggerAction(
      ACTION_IDS.importExcelModal,
      'Action:ExcelImport',
      ActionOverRecordTypes.OverTable,
      ZendraLocalizationServices.LanguageService,
    ),
    triggerAction(
      ACTION_IDS.downloadExcelTemplateTrigger,
      'Actions:ExcelTemplateDownload',
      ActionOverRecordTypes.OverTable,
      ZendraLocalizationServices.LanguageService,
    )
  ],
};

export const HARVEST_PLAN_ACTIONS_CONFIG = HARVESTPLAN_ACTIONS;

export const HARVESTPLAN_CONFIG = {
  entityName: 'HarvestPlan',
  localizationKey: 'Operational::Entity.HarvestPlan',
  fields: HARVESTPLAN_FIELDS,
  permission: 'PlanningOperation.HarvestPlans',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.PlanningOperational + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Harvest + MENU_NAME_SUFFIX,
  actions: HARVEST_PLAN_ACTION_IDS,
  actionIds: ACTION_IDS,
};
